<fisico-header [vaga]="vaga"></fisico-header>

<main id="main" class="content-detalhes-vaga">
  <ng-container *ngIf="vaga">
    <div class="container-header">
      <div class="container">
        <div class="col-md-10">
          <div class="row align-items-end">
            <div class="col-md-2 col-sm-4 col-4"></div>
            <div class="col-md-10 col-sm-8 col-8 recuo">
              <h1>{{ vaga.Part.nome }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="card-empresa">
        <div class="row">
          <div class="col-md-10 descricao">
            <div class="row align-items-end">
              <div class="col-md-2 col-sm-4 col-4">
                <div class="logo-empresa">
                  <img
                    class="img-fluid"
                    [src]="getEmpresaLogo(vaga)"
                    alt=""
                    *ngIf="!vaga.Part.sigiloNomeEmpresa"
                  />
                  <img
                    class="img-fluid"
                    src="assets/img/logotypes/confidencial.png"
                    alt="Empresa confidencial"
                    *ngIf="vaga.Part.sigiloNomeEmpresa"
                  />
                </div>
              </div>
              <div class="col-md-10 col-sm-8 col-8 recuo">
                <h2 class="mt-0" *ngIf="vaga.Part.sigiloNomeEmpresa">
                  Empresa Confidencial
                </h2>
                <h2 class="mt-0" *ngIf="!vaga.Part.sigiloNomeEmpresa">
                  {{ vaga.Empresa.Caracteristica?.Nome }}<br />
                  <span></span>
                </h2>
              </div>
            </div>
            <p
              class="text-preline text-justify mt-3"
              *ngIf="!vaga.Part.sigiloNomeEmpresa"
              #DescricaoEmpresa
            ></p>
            <p class="text-justify mt-3" *ngIf="vaga.Part.sigiloNomeEmpresa">
              Não informado
            </p>
          </div>
          <div class="col-md-2 text-center qrcode d-none d-sm-none d-md-block">
            <p><strong>Código da vaga:</strong><br />{{ vaga.CodigoVaga }}</p>
            <img
              class="img-fluid qrcode"
              src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://reachr.com.br/vaga?vaga={{
                vaga.id
              }} "
              alt="Código da vaga "
            />
          </div>
        </div>
      </div>

      <div class="d-md-none d-block">
        <div class="row mt-2">
          <div class="col-12" *ngIf="vaga.Status === 5">
            <div class="alert alert-info text-center">
              Desculpe, mas não foi possível se candidatar a esta vaga. O
              processo seletivo da vaga foi encerrada.
            </div>
          </div>
          <div class="col-12" *ngIf="vaga.Status === 4">
            <div class="alert alert-info text-center" *ngIf="">
              Desculpe, mas não foi possível se candidatar a esta vaga. O
              processo seletivo da vaga foi cancelada.
            </div>
          </div>
          <div
            class="col-12"
            *ngIf="vaga.Status !== 1 && vaga.Status !== 4 && vaga.Status !== 5"
          >
            <div class="alert alert-info text-center" *ngIf="!empresaSebrae()">
              Desculpe, mas não foi possível se candidatar a esta vaga. O
              processo seletivo da vaga esta em processamento.
            </div>
            <div class="alert alert-info text-center" *ngIf="empresaSebrae()">
              Infelizmente o período das inscrições se encerraram. O processo
              está em andamento.
            </div>
          </div>
        </div>
      </div>

      <hr class="border border-gray" />

      <div class="row publicado_em d-none d-md-flex">
        <div class="col-md-4 col-6">
          <p class="form-control-plaintext mb-2">
            Vaga publicada em
            {{
              vaga.Datas.Publicacao !== null
                ? (vaga.Datas.Publicacao | date : "dd/MM/yyyy")
                : (vaga.Datas.Cadastro | date : "dd/MM/yyyy")
            }}
          </p>
        </div>
        <div class="col-md-8 col-6 text-right">
          <!--<p>
            <button class="btn btn-primary btn-reachr-primary mb-2" *ngIf="vaga.Status == 1" (click)="openModalLogin()">Quero me candidatar</button>
            <button class="btn btn-primary btn-reachr-primary mb-2" *ngIf="vaga.Status != 1" disabled>Quero me candidatar</button>
            <button class="btn btn-primary btn-reachr-primary mb-2" (click)="compartilharVaga()" disabled>
              <i class="fa fa-share-square-o fa-lg" aria-hidden="true"></i>
              Compartilhe esta vaga
            </button>
          </p>-->
        </div>
      </div>

      <div class="row d-md-none d-flex publicado_em">
        <div class="col-md-6 col-6">
          <p>
            Vaga publicada em {{ vaga.Datas.Cadastro | date : "dd/MM/yyyy" }}
          </p>
        </div>
        <div class="col-md-6 col-6 text-right">
          <p><strong>Código da vaga:</strong> {{ vaga.CodigoVaga }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vaga">
    <div class="container">
      <div class="card-vaga mt-2 mb-4">
        <div class="row">
          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-map-marker fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{ vaga.Part.cidade?.Cidade?.trim() || "Não informado" }} </span
              >,
              <span class="icon-font-size">
                {{ vaga.Part.uf?.trim() || "Não informado" }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-briefcase fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{ vaga.Part.cluster?.Descricao?.trim() || "Não informado" }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1" *ngIf="vaga.Part.area">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-building fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{ vaga.Part.area?.trim() || "Não informado" }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-usd fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.salarioReal !== null && vaga.Part.exibirSalario
                    ? (vaga.Part.salarioReal
                      | currency : "BRL" : "symbol" : "1.2-2" : "pt-BR")
                    : vaga.EmpresaId ===
                        "1f7048e2-b768-4fb6-8ae9-b85ed02ad199" &&
                      !isVagaRedeTeia(vaga)
                    ? "Verificar o Edital"
                    : "À combinar"
                }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-graduation-cap fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.escolaridade?.Descricao?.trim() || "Não informado"
                }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-clock-o fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.periodoTrabalho?.Descricao?.trim() ||
                    "Não informado"
                }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-list fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.modeloContratacao?.Descricao?.trim() ||
                    "Não informado"
                }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-calendar fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.diaSemanaQueComecaTrabalhar?.trim() &&
                  vaga.Part.diaSemanaQueTerminaDeTrabalhar?.trim()
                    ? "De " +
                      vaga.Part.diaSemanaQueComecaTrabalhar +
                      " a " +
                      vaga.Part.diaSemanaQueTerminaDeTrabalhar
                    : "Não informado"
                }}
              </span>
            </strong>
          </div>

          <div class="col-md-4 col-6 my-1">
            <strong>
              <span class="fa-stack fa-lg icon-reachr-gray">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-calendar-o fa-stack-1x fa-inverse"></i>
              </span>
              <span class="icon-font-size">
                {{
                  vaga.Part.horarioTrabalhoSemanaComeca?.trim() &&
                  vaga.Part.horarioTrabalhoSemanaTermina?.trim()
                    ? "Das " +
                      vaga.Part.horarioTrabalhoSemanaComeca +
                      " às " +
                      vaga.Part.horarioTrabalhoSemanaTermina
                    : "Não informado"
                }}
              </span>
            </strong>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container>
    <div class="container">
      <div class="card-vaga my-4">
        <div class="p-2 text-justify">
          <h3>Descrição</h3>
          <p class="text-preline" #Descricao></p>
          <p *ngIf="vagaAgir()">
            <a
              href="{{ vaga.Part.UrlEdital }}"
              title="Download do manual do processo seletivo"
              target="_blank"
              >Edital {{ vaga.Part.NumeroEdital }} -
              {{ vaga.Part.NomeEdital }}</a
            >
          </p>
          <p *ngIf="vagaSebrae()">
            <a
              href="{{ linkSebrae }}"
              title="Download do manual do processo seletivo"
              target="_blank"
              >Comunicado - {{ vaga.Part.nome }}</a
            >
          </p>
          <div
            *ngIf="
              vagaSebrae() &&
              vaga.InternalId === 'fdc9ab04-6694-4dae-87fd-c98715c97c30'
            "
          >
            <p><em>Materiais Auxiliares para Estudo</em></p>
            <ul>
              <li>
                <a
                  href="http://www.planalto.gov.br/ccivil_03/LEIS/L8029cons.htm#art8"
                  title="Download do documento complementar: Lei 8029/90"
                  >Lei 8029/90</a
                >
              </li>
              <li>
                <a
                  href="http://www.planalto.gov.br/ccivil_03/decreto/d99570.htm"
                  title="Download do documento complementar: Decreto 99570/90"
                  >Decreto 99570/90</a
                >
              </li>
              <li>
                <a
                  href="https://www.planalto.gov.br/ccivil_03/_ato2019-2022/2021/lei/l14133.htm"
                  title="Download do documento complementar: Lei 14133/21"
                  >Lei 14133/21</a
                >
              </li>
              <li>
                <a
                  href="https://www.planalto.gov.br/ccivil_03/leis/l8666cons.htm"
                  title="Download do documento complementar: Lei 8666/93"
                  >Lei 8666/93</a
                >
              </li>
              <li>
                <a
                  href="https://www.planalto.gov.br/ccivil_03/decreto-lei/del5452.htm"
                  title="Download do documento complementar: CLT "
                  >CLT</a
                >
              </li>
              <li>
                <a
                  href="https://www.reachr.com.br/vaga/documentos/insc-391.2021-regulamento-de-licitacoes-e-contratos-sistema-sebrae.pdf"
                  title="Download do documento complementar: Regulamento de Licitações e Contratos Sistema SEBRAE"
                  >Regulamento de Licitações e Contratos Sistema SEBRAE</a
                >
              </li>
              <li>
                <a
                  href="https://www.reachr.com.br/vaga/documentos/insc-54-00-alcadas-de-assinatura.pdf"
                  title="Download do documento complementar: IN 54 - alcadas de assinatura"
                  >IN 54 - alcadas de assinatura</a
                >
              </li>
              <li>
                <a
                  href="https://www.reachr.com.br/vaga/documentos/insc-2502-central-de-compras.pdf"
                  title="Download do documento complementar: IN 25 - Central de Compras"
                  >IN 25 - Central de Compras</a
                >
              </li>
              <li>
                <a
                  href="https://www.reachr.com.br/vaga/documentos/insc-14.00-politica-de-seguranca-da-informacao.pdf"
                  title="Download do documento complementar: IN 14 - Política de Segurança da Informação"
                  >IN 14 - Política de Segurança da Informação</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vaga">
    <div class="container">
      <div class="card-vaga my-4">
        <div class="p-2 text-justify">
          <h3>Requisitos Obrigatórios</h3>
          <p class="text-preline" #RequisitosAbaixo></p>
          <p class="text-preline" *ngIf="!vaga.Part.requisitosObrigatorios">
            Não informado
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isEmpresaCBLLitio()">
    <div class="container container-cbl">
      <div class="dados-cbl card-vaga text-justify">
        <p>
          Os dados aqui enviados estão coletados pela Reachr - CNPJ:
          23.890.911/0001-37
        </p>
        <p>
          Estou ciente da coleta de dados de acordo com a LGPD ‘Lei nº
          13.709/2018’ e que a manutenção dos dados coletados pertencem a
          REACHR. Também estou ciente que a manutenção no site é via acesso de
          login e senha e que qualquer solicitação de eliminação de algum dado
          deve ser realizado pela plataforma ou contato direto com a REACHR.
          <b
            >Link Reachr -
            <a href="https://reachr.com.br">www.reachr.com.br</a></b
          >
        </p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vaga && empresaSebrae()">
    <div class="container">
      <div class="card-vaga my-4">
        <div class="p-2 text-justify">
          <h3>Etapas do processo seletivo</h3>
          <div class="list-group">
            <div
              class="list-group-item"
              *ngFor="let cronograma of vaga.Part.cronograma"
            >
              <h4 class="list-group-item-heading mb-1">
                {{ cronograma.titulo }}
              </h4>
              <p
                class="list-group-item-text mb-1"
                *ngFor="let descricaoCronograma of cronograma.descricao"
              >
                {{ descricaoCronograma }}
              </p>
              <div class="mb-2 mt-3"></div>
              <p
                class="list-group-item-text mb-1"
                *ngFor="let arquivoCronograma of cronograma.arquivo"
              >
                <a href="{{ arquivoCronograma.url }}"
                  ><i class="fa fa-download"></i>
                  {{ arquivoCronograma.nome }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vaga">
    <div class="container d-block d-md-none">
      <div class="card-vaga my-4">
        <div class="p-2">
          <h3>Compartilhe com um amigo</h3>
          <p>
            <a
              class="btn btn-primary btn-social-facebook"
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&amp;t={{
                vaga.Part.nome
              }}&amp;display=popup&amp;src=sdkpreparse'"
              title="Compartilhar no Facebook"
              target="_blank"
            >
              <img
                src="assets/img/facebook.png"
                class="social-icons mr-4"
              />Enviar via Facebook
            </a>
          </p>
          <p>
            <a
              class="btn btn-primary btn-social-whatsapp"
              href="https://api.whatsapp.com/send?text=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}"
              title="Compartilhar no Whatsapp"
              target="_blank"
            >
              <img
                src="assets/img/whatsapp.png"
                class="social-icons mr-4"
              />Enviar via Whatsapp
            </a>
          </p>
          <p>
            <a
              class="btn btn-primary btn-social-linkedin"
              href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&amp;title={{
                vaga.Part.nome
              }}&amp;source=https%3A%2F%2Fwww.reachr.com.br"
              title="Compartilhar no Linkedin"
              target="_blank"
            >
              <img
                src="assets/img/linkedin.png"
                class="social-icons mr-4"
              />Enviar via Linkedin
            </a>
          </p>
          <p>
            <a
              class="btn btn-primary btn-social-telegram"
              href="https://telegram.me/share/url?url=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&text={{ vaga.Part.nome }}"
              title="Compartilhar no Telegram"
              target="_blank"
            >
              <img
                src="assets/img/telegram.png"
                class="social-icons mr-4"
              />Enviar via Telegram
            </a>
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="vaga">
    <div class="container">
      <div class="row">
        <div class="col-12" *ngIf="vaga.Status === 5">
          <div class="alert alert-info text-center">
            Desculpe, mas não foi possível se candidatar a esta vaga. O processo
            seletivo da vaga foi encerrada.
          </div>
        </div>
        <div class="col-12" *ngIf="vaga.Status === 4">
          <div class="alert alert-info text-center">
            Desculpe, mas não foi possível se candidatar a esta vaga. O processo
            seletivo da vaga foi cancelada.
          </div>
        </div>
        <div
          class="col-12"
          *ngIf="vaga.Status !== 1 && vaga.Status !== 4 && vaga.Status !== 5"
        >
          <div class="alert alert-info text-center" *ngIf="!empresaSebrae()">
            Desculpe, mas não foi possível se candidatar a esta vaga. O processo
            seletivo da vaga esta em processamento.
          </div>
          <div class="alert alert-info text-center" *ngIf="empresaSebrae()">
            <span *ngIf="vaga.Part.tipoVaga === 0">
              Infelizmente o período das inscrições se encerraram. O processo
              está em andamento.
            </span>
            <span *ngIf="vaga.Part.tipoVaga === 1">
              Verifique o período das inscrições
            </span>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar fixed-bottom navbar-light bg-white">
      <div class="container">
        <div class="mr-auto">
          <button
            class="btn btn-primary btn-reachr-primary px-5 py-2 mb-2 h4 rounded-pill"
            *ngIf="vaga.Status === 1"
            (click)="openModalLogin()"
          >
            Quero me candidatar
          </button>
          <button
            class="btn btn-primary btn-reachr-primary px-5 py-2 mb-2 h4 rounded-pill"
            *ngIf="vaga.Status !== 1"
            disabled
          >
            Quero me candidatar
          </button>
        </div>
        <div class="navbar-text font-weight-bold text-dark d-none d-md-block">
          Compartilhe com um amigo
          <p class="text-right d-none d-md-block mb-0">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&amp;t={{
                vaga.Part.nome
              }}&amp;display=popup&amp;src=sdkpreparse'"
              title="Compartilhar no Facebook"
              target="_blank"
            >
              <img src="assets/img/facebook.png" class="social-icons" />
            </a>
            <a
              href="https://api.whatsapp.com/send?text=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}"
              title="Compartilhar no Whatsapp"
              target="_blank"
            >
              <img src="assets/img/whatsapp.png" class="social-icons" />
            </a>
            <a
              href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&amp;title={{
                vaga.Part.nome
              }}&amp;source=https%3A%2F%2Fwww.reachr.com.br"
              title="Compartilhar no Linkedin"
              target="_blank"
            >
              <img src="assets/img/linkedin.png" class="social-icons" />
            </a>
            <a
              href="https://telegram.me/share/url?url=https%3A%2F%2Fwww.reachr.com.br%2Fvaga{{
                router.url
              }}&text={{ vaga.Part.nome }}"
              title="Compartilhar no Telegram"
              target="_blank"
            >
              <img src="assets/img/telegram.png" class="social-icons" />
            </a>
          </p>
        </div>
      </div>
    </nav>
  </ng-container>
</main>

<fisico-footer></fisico-footer>
